module.exports = {
  siteUrl: 'https://healthfulinspired.com',
  siteName: 'Healthful&Inspired',
  siteTitle:
    'Healthful&Inspired: The best site to find health and weight loss reads',
  siteDescription:
    'Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!',
  siteKeywords: [
    'amazing fat burners',
    'how to lose weight fast',
    'belly fat diet',
    'belly fat exercises',
    'belly fat supplements',
    'weight loss supplements',
    'health supplements',
    'body fat supplements',
    'belly fat burners',
    'how to lose belly fat',
    'fitness',
    'workouts',
    'weight loss workouts',
    'weight loss exercises',
    'fitness exercises',
    'fitness workouts',
    'gym workouts',
    'gym exercises',
    'healthy snacks',
    'nutrition',
    'vitamins',
    'weight loss vitamins',
    'fat burning vitamins',
    'best and fastest way to lose fat',
    'fastest way to lose weight',
    'weight loss diet',
    'weight loss apple cider vinegar',
    'how to burn belly fat',
    'low carb diet',
    'fat burning supplements',
    'weight loss supplements',
    'weight loss',
    'lose weight',
    'fat burning',
    'stomach fat burning foods',
    'top 10 fat burning foods',
    'how to burn belly fat for women',
    'how to burn belly fat for men',
    'how to lose belly fat quickly',
    'how to burn belly fat fast',
    'liquid diet',
    'body fat burning supplements',
    'burn fat 1000 calories',
    'burn fat',
    'fat burn',
    'reduce fat',
    'healthful',
    'healthfulinspired',
    'healthful&inspired',
    'healthy',
    'health',
    'weight loss meal plan',
  ],
  siteLogo: '/src/images/logo/logo.png',
  remoteLogo:
    'https://s3-us-west-1.amazonaws.com/healthfulinspired/app/logo.png',
}



// WEBPACK FOOTER //
// ./siteConfig.js